import styled from 'styled-components';
import { HorizontalDivider } from '../../../../../../components/Common/horizontal-divider/horizontal-divider.component';
import { THEME } from '../../../../../../themes';

export const StyledDivider = styled(HorizontalDivider)`
  margin: ${THEME.SPACING.TINO} 0;
  opacity: ${THEME.OPACITY.GHOSTLY};
`;
